import tin_1 from "@/assets/packages/tin_1.png";
import bottle_glass_1 from "@/assets/packages/bottle_glass_1.png";
import bottle_glass_2 from "@/assets/packages/bottle_glass_2.png";
import bottle_glass_3 from "@/assets/packages/bottle_glass_3.png";
import bottle_pp_1 from "@/assets/packages/bottle_pp_1.png";
import bottle_pp_2 from "@/assets/packages/bottle_pp_2.png";
import bottle_pp_3 from "@/assets/packages/bottle_pp_3.png";
import bottle_pp_4 from "@/assets/packages/bottle_pp_4.png";
import bucket_pp_2 from "@/assets/packages/bucket_pp_2.png";
import bucket_pp_3 from "@/assets/packages/bucket_pp_3.png";
import bucket_pp_4 from "@/assets/packages/bucket_pp_4.png";
import bucket_pp_5 from "@/assets/packages/bucket_pp_5.png";
import bucket_pp_6 from "@/assets/packages/bucket_pp_6.png";
import bukcet_pp_1 from "@/assets/packages/bukcet_pp_1.png";
import can_1 from "@/assets/packages/can_1.png";
import can_2 from "@/assets/packages/can_2.png";
import can_3 from "@/assets/packages/can_3.png";
import can_4 from "@/assets/packages/can_4.png";
import jar_glass_1 from "@/assets/packages/jar_glass_1.png";
import jar_glass_2 from "@/assets/packages/jar_glass_2.png";
import jar_glass_3 from "@/assets/packages/jar_glass_3.png";
import jar_glass_4 from "@/assets/packages/jar_glass_4.png";
import jar_glass_5 from "@/assets/packages/jar_glass_5.png";
import jar_glass_6 from "@/assets/packages/jar_glass_6.png";
import jar_glass_7 from "@/assets/packages/jar_glass_7.png";
import jar_glass_8 from "@/assets/packages/jar_glass_8.png";
import jar_glass_9 from "@/assets/packages/jar_glass_9.png";
import jar_glass_10 from "@/assets/packages/jar_glass_10.png";
import jar_pp_1 from "@/assets/packages/jar_pp_1.png";
import jar_pp_2 from "@/assets/packages/jar_pp_2.png";
import jar_pp_3 from "@/assets/packages/jar_pp_3.png";
import jar_pp_4 from "@/assets/packages/jar_pp_4.png";
import tin_2 from "@/assets/packages/tin_2.png";
import vacuum from "@/assets/packages/vacuum.png";
import vacuum_2 from "@/assets/packages/vacuum_2.png";
import vacuum_3 from "@/assets/packages/vacuum_3.png";

export type LocalizedText = {
    bg: string;
    en: string;
};

export type PackagingFeature = {
    title: LocalizedText;
    description: LocalizedText;
};

export type Packaging = {
    id: string;
    title: LocalizedText;
    description: LocalizedText;
    longDescription: LocalizedText;
    features: PackagingFeature[];
    sizes?: string[]; // e.g. ["1kg", "5kg"]
    subCategories?: {
        title: LocalizedText;
        sizes: string[];
    }[];
    images: string[];
};

export const packagingData: Packaging[] = [
    {
        id: "tin-collection",
        title: { bg: "Тенекии", en: "Tins" },
        description: {
            bg: "Класическо съхранение за максимална свежест.",
            en: "Classic storage for maximum freshness.",
        },
        longDescription: {
            bg: "Нашите метални тенекии са символ на традиция и качество. Те осигуряват пълна защита от светлина и въздух, гарантирайки, че маслините запазват своя автентичен вкус и текстура за дълъг период. Идеални за големи домакинства, ресторанти и ценители, които не правят компромис с качеството.",
            en: "Our metal tins are a symbol of tradition and quality. They provide complete protection from light and air, ensuring that the olives retain their authentic taste and texture for a long period. Ideal for large households, restaurants, and connoisseurs who do not compromise on quality.",
        },
        features: [
            {
                title: { bg: "UV Защита", en: "UV Protection" },
                description: { bg: "Непропускащият материал предпазва от оксидация.", en: "Opaque material protects against oxidation." },
            },
            {
                title: { bg: "Херметическо затваряне", en: "Hermetic Seal" },
                description: { bg: "Запазва аромата и свежестта.", en: "Preserves aroma and freshness." },
            },
            {
                title: { bg: "Устойчивост", en: "Durability" },
                description: { bg: "Здрава опаковка, подходяща за транспорт.", en: "Robust packaging suitable for transport." },
            },
        ],
        subCategories: [
            {
                title: { bg: "Без костилка", en: "Pitted" },
                sizes: ["4kg", "10kg"]
            },
            {
                title: { bg: "С костилка", en: "Whole" },
                sizes: ["5kg", "13kg"]
            }
        ],
        images: [tin_1, tin_2],
    },
    {
        id: "jar-collection",
        title: { bg: "Буркани", en: "Jars" },
        description: {
            bg: "Елегантност и видимост на продукта.",
            en: "Elegance and product visibility.",
        },
        longDescription: {
            bg: "Стъклените буркани предлагат премиум изживяване, позволявайки ви да видите качеството на маслините преди да ги отворите. Перфектни за подарък или за стилно присъствие на трапезата. Стъклото е най-чистият материал за съхранение на храна, който не взаимодейства с продукта.",
            en: "Glass jars offer a premium experience, allowing you to see the quality of the olives before opening. Perfect for gifting or a stylish presence on the table. Glass is the purest material for food storage, interacting minimally with the product.",
        },
        features: [
            {
                title: { bg: "Прозрачност", en: "Transparency" },
                description: { bg: "Виждате какво купувате.", en: "See what you buy." },
            },
            {
                title: { bg: "Рециклируемост", en: "Recyclability" },
                description: { bg: "100% екологичен материал.", en: "100% eco-friendly material." },
            },
            {
                title: { bg: "Премиум визия", en: "Premium Look" },
                description: { bg: "Естетичен дизайн за всяка кухня.", en: "Aesthetic design for every kitchen." },
            },
        ],
        subCategories: [
            {
                title: { bg: "Без костилка", en: "Pitted" },
                sizes: ["180g", "340g", "500g"]
            },
            {
                title: { bg: "С костилка", en: "Whole" },
                sizes: ["200g", "400g", "600g"]
            }
        ],
        images: [jar_glass_2, jar_glass_1, jar_glass_7, jar_glass_4, jar_glass_5, jar_glass_6, jar_glass_3, jar_glass_8, jar_glass_9, jar_glass_10],
    },
    {
        id: "glass-bottles",
        title: { bg: "Стъклени Бутилки", en: "Glass Bottles" },
        description: {
            bg: "За нашите най-фини зехтини.",
            en: "For our finest olive oils.",
        },
        longDescription: {
            bg: "Специално подбрани тъмни стъклени бутилки, които предпазват ценния зехтин от слънчева светлина. Дизайнът е ергономичен и удобен за наливане, като същевременно добавя нотка изисканост към вашата кухня.",
            en: "Specially selected dark glass bottles that protect precious olive oil from sunlight. The design is ergonomic and easy to pour, while adding a touch of sophistication to your kitchen.",
        },
        features: [
            {
                title: { bg: "UV Филтър", en: "UV Filter" },
                description: { bg: "Тъмно стъкло за защита на качеството.", en: "Dark glass to protect quality." },
            },
            {
                title: { bg: "Дозатор", en: "Pourer" },
                description: { bg: "За прецизно и чисто наливане.", en: "For precise and clean pouring." },
            },
        ],
        sizes: ["0.250L", "0.5L", "1L"],
        images: [bottle_glass_3, bottle_glass_1, bottle_glass_2],
    },
    {
        id: "plastic-bottles",
        title: { bg: "Пластмасови Бутилки", en: "Plastic Bottles" },
        description: {
            bg: "Лекота и удобство за всеки ден.",
            en: "Lightness and convenience for every day.",
        },
        longDescription: {
            bg: "Практични PET бутилки, които са леки и нечупливи. Идеални за пикник, пътуване или за ежедневна употреба в натоварената кухня. Материалът е безопасен за храни и запазва качествата на продукта.",
            en: "Practical PET bottles that are light and unbreakable. Ideal for picnics, travel, or everyday use in a busy kitchen. The material is food-safe and preserves product qualities.",
        },
        features: [
            {
                title: { bg: "Лекота", en: "Lightweight" },
                description: { bg: "Лесни за пренасяне и употреба.", en: "Easy to carry and use." },
            },
            {
                title: { bg: "Нечупливост", en: "Unbreakable" },
                description: { bg: "Безопасни за деца и транспорт.", en: "Safe for children and transport." },
            },
        ],
        sizes: ["0.5L", "1L", "3L", "5L"],
        images: [bottle_pp_3, bottle_pp_2, bottle_pp_1, bottle_pp_4],
    },
    {
        id: "plastic-buckets",
        title: { bg: "Пластмасови Кофи", en: "Plastic Buckets" },
        description: {
            bg: "Икономично решение за големи количества.",
            en: "Economical solution for large quantities.",
        },
        longDescription: {
            bg: "Здрави полипропиленови кофи с капак, предназначени за съхранение на по-големи количества маслини в саламура. Удобни за HoReCa сектора или за истински любители на маслините.",
            en: "Sturdy polypropylene buckets with lids, designed for storing larger quantities of olives in brine. Convenient for the HoReCa sector or true olive lovers.",
        },
        features: [
            {
                title: { bg: "Вместимост", en: "Capacity" },
                description: { bg: "Голям обем на достъпна цена.", en: "Large volume at an affordable price." },
            },
            {
                title: { bg: "Многократна употреба", en: "Reusable" },
                description: { bg: "Здрава кофа, която може да се използва отново.", en: "Sturdy bucket that can be reused." },
            },
        ],
        sizes: ["0.350kg", "0.700kg", "1kg", "1.5kg", "3kg"],
        images: [bucket_pp_2, bukcet_pp_1, bucket_pp_3, bucket_pp_4, bucket_pp_5, bucket_pp_6],
    },
    {
        id: "cans",
        title: { bg: "Консерви", en: "Cans" },
        description: {
            bg: "Дълготрайност и компактност.",
            en: "Longevity and compactness.",
        },
        longDescription: {
            bg: "Металните консерви са перфектни за дългосрочно съхранение. Те са компактни, лесни за подреждане и гарантират абсолютна херметичност. Подходящи за пътуване и за запасяване.",
            en: "Metal cans are perfect for long-term storage. They are compact, easy to stack, and guarantee absolute airtightness. Suitable for travel and stocking up.",
        },
        features: [
            {
                title: { bg: "Компактност", en: "Compactness" },
                description: { bg: "Заемат малко място.", en: "Take up little space." },
            },
            {
                title: { bg: "Easy Open", en: "Easy Open" },
                description: { bg: "Лесно отваряне без инструменти (за някои размери).", en: "Easy opening without tools (for some sizes)." },
            },
        ],
        sizes: ["1.5kg (3150ml)"], // Default general size
        subCategories: [
            {
                title: { bg: "Без костилка", en: "Pitted" },
                sizes: ["2kg (4400ml)"]
            },
            {
                title: { bg: "С костилка", en: "Whole" },
                sizes: ["2.5kg (4400ml)"]
            }
        ],
        images: [can_1, can_2, can_3, can_4],
    },
    {
        id: "vacuum-packs",
        title: { bg: "Вакуум Опаковки", en: "Vacuum Packs" },
        description: {
            bg: "Максимална свежест с минимален обем.",
            en: "Maximum freshness with minimum volume.",
        },
        longDescription: {
            bg: "Вакуумните опаковки премахват въздуха, за да спрат окислителните процеси и да запазят маслините свежи като в деня на брането. Те са леки, гъвкави и заемат минимално място в хладилника.",
            en: "Vacuum packs remove air to stop oxidation processes and keep olives as fresh as the day they were harvested. They are light, flexible, and take up minimal space in the fridge.",
        },
        features: [
            {
                title: { bg: "Без саламура", en: "Brine-free" },
                description: { bg: "Чист продукт, готов за консумация.", en: "Pure product, ready to eat." },
            },
            {
                title: { bg: "Гъвкавост", en: "Flexibility" },
                description: { bg: "Удобни за всяко пространство.", en: "Convenient for any space." },
            },
        ],
        sizes: ["170g", "200g", "250g", "400g", "3kg"],
        images: [vacuum_3, vacuum, vacuum_2],
    },
    {
        id: "plastic-jars",
        title: { bg: "Пластмасови Буркани", en: "Plastic Jars" },
        description: {
            bg: "Удобство и безопасност.",
            en: "Convenience and safety.",
        },
        longDescription: {
            bg: "Леките и нечупливи пластмасови буркани са отлична алтернатива за ситуации, където безопасността е приоритет. Подходящи за транспорт, излети и ежедневна употреба, предлагайки видимост на продукта.",
            en: "Lightweight and unbreakable plastic jars are an excellent alternative for situations where safety is a priority. Suitable for transport, outings, and daily use, offering product visibility.",
        },
        features: [
            {
                title: { bg: "Нечупливост", en: "Unbreakable" },
                description: { bg: "Безопасна алтернатива на стъклото.", en: "Safe alternative to glass." },
            },
            {
                title: { bg: "Лекота", en: "Lightweight" },
                description: { bg: "По-леки за носене.", en: "Lighter to carry." },
            },
        ],
        sizes: ["800g", "900g", "2kg"],
        images: [jar_pp_4, jar_pp_3, jar_pp_2, jar_pp_1],
    },
];
